var version = {
    "name":      "dativery",
    "buildDateCode": "20260810-104833",
    "buildDate": "Mon Aug 10 2026 10:48:33 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260810-104833",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;